import {atom} from "jotai";

export const hideDetailsAtom = atom(false);